module.exports = __webpack_public_path__ + "img/banner1.5d2d5f89.jpg";